import * as React from "react";
import { KickOffState } from "../KickOffState";
import { LiveScore } from "../LiveScore";
export const LiveDetails = (props) => React.createElement(React.Fragment, null,
    React.createElement(LiveScore, { event: props.event, componentPrefix: props.componentPrefix }),
    props.event.isInKickOffState &&
        React.createElement(KickOffState, { event: props.event, dict: props.dict, componentPrefix: props.componentPrefix }));
//# sourceMappingURL=LiveDetails.js.map